// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + ({"806":"4163ae0c","2366":"1d2671aa"}[chunkId] || chunkId) + "." + {"806":"ebcbb0239cefa5df","2366":"0b38834ffa284870","5414":"2d0b2ffefb17c483","7240":"920ad637f4c84913","8270":"f5d3011c86445ab2"}[chunkId] + ".js";
};